export const POSTS = [
    {
        slug: 'coffee-roasting-team-building-events-bay-area',
        title: 'The Best Team Building Event in the Bay Area Is One Your Team Has Never Done Before',
        date: 'March 10, 2026',
        category: 'Classes',
        image: '/images/team.jpg',
        excerpt: 'Team happy hours and escape rooms are fine. But Bay Area companies looking for a team building event that actually creates lasting connection keep landing on the same answer: hands-on coffee roasting.',
        content: [
            {
                type: 'paragraph',
                text: 'Every HR manager and team lead in the Bay Area has been asked the same question: "What are we doing for the team this quarter?" The usual answers — happy hour, escape room, cooking class, axe throwing — are fine. But if you\'re looking for a team building event in the Bay Area that your team will still be talking about six months later, the answer is coffee roasting.'
            },
            {
                type: 'paragraph',
                text: 'At OFFF THE ROAST, we\'ve designed a coffee roasting experience specifically for corporate groups across the SF Bay Area. We\'ve hosted teams from Google, Meta, Figure AI, and dozens of other companies. Here\'s why it works — and how to bring it to your team.'
            },
            {
                type: 'heading',
                text: 'Why Coffee Roasting Works as a Team Building Event'
            },
            {
                type: 'paragraph',
                text: 'Great team building doesn\'t come from forced fun — it comes from shared challenge. When a group faces something genuinely new together, the usual workplace dynamics drop away. Coffee roasting is a perfect vehicle for that. Nobody on your team has done a professional drum roast before. The learning curve is equal, the stakes are low, and the process demands the same skills your team uses at work every day: communication, attention to detail, real-time decision making, and collaboration under a time window.'
            },
            {
                type: 'callout',
                label: 'WHAT MAKES IT DIFFERENT',
                text: 'Unlike team activities that reward people who already have skills (cooking, trivia, sports), roasting puts every participant on the same footing from minute one. No one has an unfair advantage. That shared first-timer experience is one of the fastest ways to build genuine connection across a team.'
            },
            {
                type: 'heading',
                text: 'What Happens During the Session'
            },
            {
                type: 'paragraph',
                text: 'Each coffee roasting team building session runs through the full journey — from raw green beans to a finished bag your team can take home. We cover where the beans come from, why origin and altitude matter, and what the roast profile actually does to flavor. Then your team gets hands-on at the drum roaster, watching temperature climb, tracking color and aroma, and learning to read the signals that tell you when a roast is ready.'
            },
            {
                type: 'paragraph',
                text: 'After roasting, the group cups together — tasting what they made, identifying flavor notes, and comparing results across different roast decisions. It\'s part science class, part sensory experience, and entirely unlike anything else on the Bay Area team building menu.'
            },
            {
                type: 'stat-grid',
                label: 'BY THE NUMBERS',
                stats: [
                    { value: '2–3 hrs', label: 'Average session length\nfor corporate groups' },
                    { value: '100%', label: 'Hands-on — every\nparticipant roasts' },
                    { value: '1 bag', label: 'Custom-roasted coffee\neach person takes home' },
                    { value: 'All sizes', label: 'We accommodate small\nteams to large groups' },
                ]
            },
            {
                type: 'heading',
                text: 'On-Site or Off-Site: We Come to You'
            },
            {
                type: 'paragraph',
                text: 'We offer two booking formats for Bay Area corporate team building:'
            },
            {
                type: 'paragraph',
                text: 'On-site: We bring our professional roasting equipment directly to your Bay Area office. You don\'t need to organize transportation, book a venue, or coordinate a field trip. We set up, run the session, and pack out — your team just shows up. This is the most popular option for Bay Area tech companies who want a seamless, high-quality experience without leaving the building.'
            },
            {
                type: 'paragraph',
                text: 'Off-site: Your team joins us at one of our beautiful partner cafés in the San Jose and Santa Clara area. This gives the event a distinct "field trip" feel that creates its own natural energy. Getting the team out of the office together — even for a few hours — changes the dynamic in ways that matter.'
            },
            {
                type: 'callout',
                label: 'COMPANIES WE\'VE WORKED WITH',
                text: 'We\'ve hosted corporate team building sessions for Google, Meta, Figure AI, and teams from across the SF Bay Area tech ecosystem. Whether it\'s a quarterly team event, a new-hire onboarding, an executive offsite, or a company anniversary, we\'ve run it.'
            },
            {
                type: 'heading',
                text: 'Team Building Events Across the Entire Bay Area'
            },
            {
                type: 'paragraph',
                text: 'Based in San Jose, we serve companies throughout the full SF Bay Area. Whether your office is in San Francisco, Oakland, Palo Alto, Mountain View, Sunnyvale, Cupertino, Santa Clara, Fremont, Berkeley, or anywhere else in Silicon Valley and the South Bay — we travel to you. No setup stress, no logistics headaches. We handle everything.'
            },
            {
                type: 'paragraph',
                text: 'Looking for team building events in San Francisco specifically? We make it easy — our on-site format means your SF-based team doesn\'t have to go anywhere. We bring the roasting experience to you, equipment and all.'
            },
            {
                type: 'heading',
                text: 'What Your Team Takes Away'
            },
            {
                type: 'paragraph',
                text: 'Beyond the connection and shared experience, every participant leaves with a bag of coffee they roasted themselves. That\'s a tangible, personalized takeaway that keeps the memory alive. We\'ve heard from event coordinators months after a session that their team still uses the experience as a reference point — "remember when we burned the first batch?" That kind of shared story is exactly what team building is supposed to create.'
            },
            {
                type: 'paragraph',
                text: 'We also believe the best corporate events are the ones where people genuinely learn something. Our sessions aren\'t padded with filler. Every part of the roasting process — from green bean selection to first crack to the cup — teaches something real about craft, decision making, and why the details matter. It\'s the kind of event where your team comes out feeling like they actually know something new. That\'s rare, and it shows.'
            },
            {
                type: 'heading',
                text: 'Book Your Bay Area Team Building Event'
            },
            {
                type: 'paragraph',
                text: 'If you\'re searching for a team building event in the Bay Area that stands apart from the usual options, this is it. Reach out through our Team Building page or submit an inquiry and we\'ll help you lock in your date, format, and group size. We respond to all inquiries quickly because we know event planning has real deadlines.'
            },
            {
                type: 'callout',
                label: 'READY TO BOOK?',
                text: 'Visit our Team Building page at offftheroast.com/team-building or fill out the inquiry form to reserve your session. Available for groups of all sizes, throughout the SF Bay Area.'
            },
        ]
    },
    {
        slug: 'gesha-geisha-coffee-origin-most-expensive',
        title: 'Gesha vs. Geisha: The Origin, Rise & Mystique of the World\'s Most Expensive Coffee',
        date: 'March 6, 2026',
        category: 'Coffee Education',
        image: '/images/panama geisha.jpg',
        excerpt: 'It started as a wild plant in a remote Ethiopian forest. Today it sells for over $1,000 per pound and has reshaped the entire specialty coffee world. This is the story of Gesha — the most extraordinary coffee ever discovered.',
        content: [
            {
                type: 'paragraph',
                text: 'If you\'ve spent any time in the specialty coffee world, you\'ve heard the name. Gesha — sometimes spelled Geisha — is the coffee that redefined what a cup could taste like, broke every auction record in existence, and turned the entire industry upside down in a single moment in 2004. But where does it come from? Why does it taste the way it does? And why does it cost more per pound than some people\'s rent?'
            },
            {
                type: 'paragraph',
                text: 'The story of Gesha is one of the most remarkable journeys in food history — from an obscure forest in Ethiopia, to near-extinction, to the most coveted coffee on the planet. Here\'s the full origin, development, and science behind why this variety commands prices that shock even seasoned coffee professionals.'
            },
            {
                type: 'heading',
                text: 'Where Did Gesha Come From? The Ethiopian Origin'
            },
            {
                type: 'paragraph',
                text: 'The Gesha variety takes its name from the town of Gesha in the Kaffa region of southwestern Ethiopia — one of the most biodiverse coffee-growing areas on Earth and widely considered the geographic origin of all coffee. In this dense highland forest, wild coffee plants have grown for thousands of years, and Gesha was one of hundreds of naturally occurring varieties thriving in the undergrowth.'
            },
            {
                type: 'paragraph',
                text: 'In the 1930s and 1940s, British researchers exploring Ethiopia\'s forests collected samples of wild coffee varieties, including the Gesha plant, and sent them to the Coffee Research Station in Kenya. The variety was noted for its unusual physical appearance — long, slender leaves, elongated coffee cherries, and an open branch structure unlike most commercial Arabica varieties. But at the time, nobody was thinking about flavor. The focus was disease resistance.'
            },
            {
                type: 'callout',
                label: 'A NAME WITH TWO SPELLINGS',
                text: '"Gesha" is the correct spelling — it refers to the Ethiopian town. "Geisha" is the alternate romanization that became common in Panama. Both refer to the same variety. You\'ll see both used interchangeably throughout the coffee world.'
            },
            {
                type: 'heading',
                text: 'The Journey to Central America: A Forgotten Variety'
            },
            {
                type: 'paragraph',
                text: 'In the 1950s, Gesha seeds made their way from Ethiopia through Kenya and Costa Rica\'s CATIE research center, eventually arriving in Panama. Farmers there planted the variety alongside their commercial Typica and Bourbon plants — but it was largely ignored. Gesha produced significantly fewer cherries per tree than standard commercial varieties, making it economically unattractive. Many farmers ripped the plants out. The few who kept them did so reluctantly, appreciating that the trees seemed to survive leaf rust — the devastating fungal disease that destroys coffee farms worldwide.'
            },
            {
                type: 'paragraph',
                text: 'For nearly five decades, Gesha sat quietly on the slopes of Panama\'s Baru volcano, overlooked, undervalued, and almost entirely forgotten. It took one family\'s curiosity — and one extraordinary tasting — to change everything.'
            },
            {
                type: 'heading',
                text: 'The Moment That Changed Everything: Panama 2004'
            },
            {
                type: 'paragraph',
                text: 'In 2004, the Peterson family of Hacienda La Esmeralda in Boquete, Panama noticed something strange. One section of their farm — planted with those old Gesha trees — was producing coffee that tasted completely unlike anything else on the farm. Curious, they separated that lot and submitted it to the Best of Panama competition, a prestigious annual cupping competition among Panama\'s top producers.'
            },
            {
                type: 'paragraph',
                text: 'The judges were stunned. Coffee professionals with decades of experience sat in silence after the first sip. The Gesha lot scored higher than any coffee in the competition\'s history. The cup tasted like jasmine flowers, bergamot, ripe mango, mandarin orange — flavors that coffee simply was not supposed to have. It sold at auction for $21 per pound, shattering the previous record. The specialty coffee world had never seen anything like it.'
            },
            {
                type: 'callout',
                label: 'THE AUCTION RECORD',
                text: 'In 2019, a washed Gesha from Elida Estate in Panama sold for $1,029 per pound — the highest price ever paid for coffee at public auction. In 2021, a natural-process Gesha broke $1,300 per pound. These are not typos.'
            },
            {
                type: 'stat-grid',
                label: 'GESHA BY THE NUMBERS',
                stats: [
                    { value: '2004', label: 'Year Gesha won its\nfirst Best of Panama title' },
                    { value: '$1,029/lb', label: 'Record auction price\npaid in 2019' },
                    { value: '1,700m+', label: 'Minimum elevation\nfor peak quality' },
                    { value: '90+', label: 'SCA score — the\nhighest tier in specialty coffee' },
                ]
            },
            {
                type: 'heading',
                text: 'Why Is Gesha So Expensive?'
            },
            {
                type: 'paragraph',
                text: 'The price of Gesha is not a marketing trick. It\'s the result of several compounding factors that make it genuinely difficult and expensive to produce at the quality level the market demands.'
            },
            {
                type: 'paragraph',
                text: 'First, yield. A standard commercial coffee tree produces enough cherries to yield roughly one pound of roasted coffee per year. A Gesha tree produces a fraction of that. The long, sprawling branch structure and smaller cherry clusters mean farmers get dramatically less output per plant — with dramatically higher input of labor, water, and care.'
            },
            {
                type: 'paragraph',
                text: 'Second, altitude dependency. Gesha only develops its signature flavor complexity at very high elevations — typically above 1,700 meters, with the finest lots grown above 1,900 meters. At this altitude, cool temperatures slow the development of the coffee cherry, allowing sugars and acids to accumulate over a longer period and producing the extraordinary flavor density Gesha is known for. The farms capable of growing it at this altitude are limited in number and small in size.'
            },
            {
                type: 'elevation-bar',
                label: 'HOW ELEVATION TRANSFORMS GESHA',
                bars: [
                    { label: 'Flavor', low: 'Below 1,200m: Flat, generic. No floral character.', high: '1,700m+: Jasmine, bergamot, mango, tea-like clarity.' },
                    { label: 'Cherry Development', low: 'Fast ripening. Low sugar accumulation.', high: 'Slow ripening. Dense sugars and complex acids.' },
                    { label: 'Cup Quality', low: 'Commercial grade. Simple, forgettable.', high: 'Specialty grade. 90+ SCA score. Auction-worthy.' },
                ]
            },
            {
                type: 'paragraph',
                text: 'Third, processing precision. Because Gesha commands such high prices, the post-harvest processing must be flawless. Even minor fermentation errors or drying inconsistencies destroy the delicate flavor compounds that make it worth the premium. This requires highly skilled, careful, labor-intensive processing — adding further cost.'
            },
            {
                type: 'heading',
                text: 'What Does Gesha Actually Taste Like?'
            },
            {
                type: 'paragraph',
                text: 'Nothing else in coffee tastes quite like Gesha — and that is not an exaggeration. Most high-quality coffees are described in terms of chocolate, caramel, nuts, red fruits, or citrus. Gesha operates in a completely different register. The cup is typically described as tea-like in body — delicate and transparent rather than heavy. The aroma alone is striking: jasmine, orange blossom, bergamot. The flavor follows with tropical fruit (mango, papaya, passionfruit), stone fruit (peach, apricot), and a clean, vibrant acidity that finishes long and sweet.'
            },
            {
                type: 'paragraph',
                text: 'First-time Gesha drinkers frequently don\'t believe what they\'re tasting is coffee. The flavor is so distinct, so far outside the expected range, that it genuinely reframes what the beverage can be. This is not a subtle difference — it\'s a fundamental shift in the sensory experience of coffee.'
            },
            {
                type: 'heading',
                text: 'Where Is Gesha Grown Today?'
            },
            {
                type: 'paragraph',
                text: 'After the 2004 breakthrough, coffee farmers worldwide scrambled to plant Gesha. Today it is grown in several countries — though quality varies enormously based on elevation and terroir. Panama remains the benchmark, but exceptional Gesha is also being produced in Colombia, Costa Rica, and Ethiopia, where the variety originally came from.'
            },
            {
                type: 'region-cards',
                label: 'NOTABLE GESHA ORIGINS',
                regions: [
                    { name: 'Panama', elevation: '1,600–2,000m', soil: 'Volcanic loam', notes: 'The benchmark. Hacienda La Esmeralda in Boquete set the standard. Floral, fruit-forward, record auction prices.' },
                    { name: 'Ethiopia', elevation: '1,800–2,200m', soil: 'Ancient highland', notes: 'The original home of wild Gesha. Ethiopian lots offer an earthier, more complex expression tied to the land where the variety evolved.' },
                    { name: 'Colombia', elevation: '1,700–2,100m', soil: 'Volcanic clay', notes: 'High-altitude farms in Huila and Nariño are producing world-class Gesha at more accessible prices than Panama.' },
                    { name: 'Guatemala', elevation: '1,600–2,000m', soil: 'Volcanic', notes: 'Volcanic soil and extreme altitude combine with the Gesha variety to produce exceptional lots. Our Guatemala Gesha is grown in these conditions.', highlight: true },
                    { name: 'Costa Rica', elevation: '1,500–1,900m', soil: 'Volcanic loam', notes: 'Small micro-mill producers in Tarrazu and Chirripó are producing clean, expressive Gesha with a structured acidity.' },
                ]
            },
            {
                type: 'heading',
                text: 'Our Guatemala Gesha'
            },
            {
                type: 'paragraph',
                text: 'At OFFF THE ROAST, we source our Gesha from Guatemala — grown on the volcanic highlands where elevation and mineral-rich soil combine with the sensitivity of the Gesha variety to produce something genuinely special. It\'s available in 8oz bags, roasted to order. If you\'ve been curious about what all the Gesha conversation is about, this is your entry point.'
            },
            {
                type: 'callout',
                label: 'TRY IT YOURSELF',
                text: 'Our Guatemala Gesha is available in the Our Coffee section — 8oz, roasted to order. It\'s the most approachable way to experience what made the coffee world stop and pay attention.'
            },
        ]
    },
    {
        slug: 'why-volcanic-mountains-produce-the-best-coffee',
        title: 'Why the World\'s Best Coffee Grows on Volcanic Mountains',
        date: 'March 1, 2026',
        category: 'Coffee Education',
        image: '/images/Vocanic Mountain.jpg',
        excerpt: 'There\'s a reason the most celebrated coffees on earth — Ethiopian Yirgacheffe, Guatemala Gesha, Yemen Mokha Matari — all share one thing: they grow on or near volcanic terrain at high altitude. This is the science behind why.',
        content: [
            {
                type: 'paragraph',
                text: 'The next time someone hands you an exceptional cup of coffee and you trace its origin on a map, notice something: the dot almost always sits on or near a volcanic mountain range, usually between 1,200 and 2,200 meters above sea level. This isn\'t coincidence. It\'s geology, climate, and biology working together to create conditions that ordinary farmland simply cannot replicate.'
            },
            {
                type: 'paragraph',
                text: 'In this post, we break down exactly why elevation and volcanic soil matter so much — and why the world\'s most prized coffees are almost always grown in these high-altitude volcanic regions.'
            },
            {
                type: 'heading',
                text: 'The Coffee Belt: Where Elevation Meets the Equator'
            },
            {
                type: 'paragraph',
                text: 'Coffee grows commercially within a band that runs roughly 25 degrees north and south of the equator — known as the Coffee Belt. But within that band, not all coffee is equal. The farms that produce the world\'s most complex, sought-after beans are almost always found at significant elevation, typically on the slopes of dormant or active volcanoes.'
            },
            {
                type: 'stat-grid',
                label: 'ELEVATION & QUALITY TIERS',
                stats: [
                    { value: '600–900m', label: 'Commercial Grade\nMild, simple flavor' },
                    { value: '900–1,200m', label: 'High Grown (HG)\nClean, balanced cup' },
                    { value: '1,200–1,500m', label: 'Strictly High Grown\nBright acidity, complexity' },
                    { value: '1,500–2,200m', label: 'Specialty Grade\nFloral, fruit-forward, exceptional' },
                ]
            },
            {
                type: 'heading',
                text: 'What Volcanic Soil Actually Does to Coffee'
            },
            {
                type: 'paragraph',
                text: 'Volcanic soil — formed from the weathering of lava rock over thousands of years — is among the most mineral-rich agricultural soil on Earth. It typically contains high concentrations of potassium, phosphorus, magnesium, zinc, and iron: nutrients that are directly absorbed by the coffee plant and contribute to the complexity of flavor in the final bean.'
            },
            {
                type: 'paragraph',
                text: 'But mineral content is only part of the story. Volcanic soils are also exceptionally porous and well-draining. Coffee roots hate sitting in waterlogged soil — too much moisture causes root rot and dilutes flavor development. Volcanic earth lets water drain freely while retaining just enough moisture to feed the plant. This stress-and-balance dynamic is key to producing dense, complex beans.'
            },
            {
                type: 'callout',
                label: 'WHY DRAINAGE MATTERS',
                text: 'When coffee roots are slightly stressed by well-draining soil — never waterlogged, never bone dry — the plant concentrates its energy into producing fewer but more nutrient-dense cherries. This is the same principle behind dry-farmed wine grapes. Mild stress = concentrated flavor.'
            },
            {
                type: 'heading',
                text: 'The Role of Elevation: Slow Growth, Dense Beans'
            },
            {
                type: 'paragraph',
                text: 'Temperature drops roughly 6°C (about 11°F) for every 1,000 meters of elevation gained. At high altitude, this means coffee cherries ripen slowly — often taking nine to eleven months from flowering to harvest, compared to six to seven months at lower elevations. This extended maturation period gives the cherry more time to develop sugars, acids, and aromatic compounds.'
            },
            {
                type: 'paragraph',
                text: 'The result is a harder, denser bean. Harder beans require more energy to roast and are more challenging to profile correctly — but they hold significantly more flavor potential. This is why specialty roasters prize high-altitude coffees and why certifications like "Strictly Hard Bean" (SHB) and "Strictly High Grown" (SHG) command premium prices.'
            },
            {
                type: 'elevation-bar',
                label: 'HOW ELEVATION SHAPES THE BEAN',
                bars: [
                    { label: 'Cherry Ripening Time', low: 'Faster (6–7 months)', high: 'Slower (9–11 months)' },
                    { label: 'Bean Density', low: 'Softer, more porous', high: 'Denser, harder' },
                    { label: 'Sugar Development', low: 'Lower', high: 'Higher' },
                    { label: 'Aromatic Complexity', low: 'Simple', high: 'Layered, complex' },
                    { label: 'Acidity', low: 'Flat', high: 'Bright, nuanced' },
                ]
            },
            {
                type: 'heading',
                text: 'Temperature Swings: The Secret Ingredient'
            },
            {
                type: 'paragraph',
                text: 'High-altitude volcanic regions also experience dramatic diurnal temperature variation — the difference between daytime and nighttime temperatures. In many of the world\'s premier coffee regions, temperatures swing 15–20°C between day and night. This thermal cycling acts as a natural stress trigger for the coffee plant.'
            },
            {
                type: 'paragraph',
                text: 'During warm days, the plant photosynthesizes and builds sugars. During cool nights, cellular activity slows dramatically, which slows the respiration of those sugars — essentially preserving them in the bean rather than burning them off. The result: higher residual sugars in the ripe cherry, which translate directly to sweetness and body in the cup.'
            },
            {
                type: 'callout',
                label: 'THE DIURNAL EFFECT',
                text: 'A 15–20°C day-to-night temperature swing at altitude acts like a natural preservative for the sugars built up during the day. Those preserved sugars are what give high-grown coffees their characteristic sweetness, round body, and extended finish — qualities that low-altitude coffees structurally cannot develop at the same level.'
            },
            {
                type: 'heading',
                text: 'The World\'s Great Volcanic Coffee Regions'
            },
            {
                type: 'paragraph',
                text: 'Nearly every iconic coffee origin sits on or beside volcanic terrain. Here\'s a look at the regions that define high-altitude volcanic coffee — including two you\'ll find in our shop.'
            },
            {
                type: 'region-cards',
                regions: [
                    {
                        name: 'Ethiopia — Yirgacheffe & Sidama',
                        elevation: '1,700 – 2,200m',
                        soil: 'Ancient volcanic highland',
                        notes: 'The birthplace of coffee. Yirgacheffe and Sidama sit on some of the oldest volcanic earth on the continent. Expect floral aromas, bergamot, stone fruit, and a tea-like delicacy that has made Ethiopian coffee the benchmark for washed specialty coffee worldwide.',
                    },
                    {
                        name: 'Yemen — Al Hajarah & Bani Matari',
                        elevation: '1,500 – 2,500m',
                        soil: 'Ancient terraced volcanic slopes',
                        notes: 'Yemen\'s coffee is among the rarest on earth, grown on hand-built terraces carved into volcanic mountain faces over centuries. The extreme altitude, dry conditions, and ancient cultivars create a wine-like, deeply complex cup unlike anything else. Our Yemen Mokha Matari comes from the Bani Matari region at over 2,000 meters.',
                        highlight: true,
                    },
                    {
                        name: 'Guatemala — Huehuetenango & Antigua',
                        elevation: '1,500 – 2,000m',
                        soil: 'Volcanic ash-enriched clay',
                        notes: 'Guatemala\'s western highlands sit on the Sierra de los Cuchumatanes, a non-volcanic limestone range — but the Antigua valley and surrounding areas receive volcanic ash deposits from nearby active volcanoes. This combination of altitude and volcanic mineral influx produces the bright acidity and chocolate-fruit complexity Guatemala is known for. Our Guatemala Gesha is sourced from Huehuetenango.',
                        highlight: true,
                    },
                    {
                        name: 'Colombia — Nariño & Huila',
                        elevation: '1,700 – 2,300m',
                        soil: 'Andean volcanic loam',
                        notes: 'Colombia\'s southern highlands — particularly Nariño — sit at extraordinary elevations in the Andes, a volcanic mountain chain. The proximity to the equator means that despite the altitude, there\'s enough warmth for the coffee to ripen. The result is some of the most consistently high-scoring coffee in the world: sweet, caramel-forward, with bright citrus acidity.',
                    },
                    {
                        name: 'Kenya — Mount Kenya Slopes',
                        elevation: '1,400 – 2,100m',
                        soil: 'Red volcanic laterite',
                        notes: 'Kenya\'s renowned SL28 and SL34 cultivars grow on the volcanic slopes of Mount Kenya in rich, red laterite soil. This soil type is extremely high in iron and aluminum — elements that contribute to the bold, wine-like blackcurrant acidity that makes Kenyan coffee unlike anything else. Kenya is one of the few origins where the soil\'s mineral character is almost directly detectable in the cup.',
                    },
                    {
                        name: 'Indonesia — Sumatra & Flores',
                        elevation: '1,200 – 1,800m',
                        soil: 'Active volcanic soil',
                        notes: 'Indonesia sits on the Pacific Ring of Fire, making its coffee islands among the most volcanically active on earth. Sumatran coffee grown on the slopes of active volcanoes like Sinabung develops the earthy, full-bodied, low-acid character it\'s famous for. The "wet hulling" process combined with volcanic mineral content produces a cup that is distinctively deep and complex.',
                    },
                ]
            },
            {
                type: 'heading',
                text: 'What This Means in Your Cup'
            },
            {
                type: 'paragraph',
                text: 'When you taste a high-grown volcanic coffee, you\'re tasting the accumulation of thousands of years of geological history: minerals leached slowly from ancient lava flows into the soil, absorbed by the plant, concentrated into the cherry over months of slow mountain ripening, and preserved by cool nights into the final bean.'
            },
            {
                type: 'paragraph',
                text: 'This is why specialty coffee professionals track elevation, soil type, and proximity to volcanic terrain with the same attention that winemakers track terroir. Because that\'s exactly what it is — terroir. The flavor of a place, captured in a bean.'
            },
            {
                type: 'paragraph',
                text: 'It\'s also why not all coffee is the same price. A bag of low-grown commercial coffee and a bag of high-altitude volcanic specialty coffee may look identical, but they represent entirely different levels of biological investment, geographic luck, and farming care.'
            },
            {
                type: 'callout',
                label: 'TRY IT FOR YOURSELF',
                text: 'We carry two high-altitude volcanic coffees in our shop: Yemen Mokha Matari (2,000m+, ancient volcanic terraces, 8 oz — $32) and Guatemala Gesha (Huehuetenango highlands, volcanic ash-enriched soil, 8 oz — $35). Both are available in limited quantities. If you want to taste what elevation and volcanic terroir actually mean in a cup, these are your starting point.',
            },
            {
                type: 'paragraph',
                text: 'Curious about how roasting affects these high-altitude beans? Come experience it firsthand in one of our roasting classes — where you\'ll learn to read and respond to exactly what these extraordinary coffees need.'
            },
        ]
    },
    {
        slug: 'what-happens-in-our-roasting-class',
        title: 'What Happens in Our Coffee Roasting Class?',
        date: 'February 20, 2026',
        category: 'Classes',
        image: '/images/whathappeninclass.jpg',
        excerpt: 'From selecting green beans to pulling your first roast, here\'s a behind-the-scenes look at what you\'ll experience when you book a session with OFFF THE ROAST.',
        content: [
            {
                type: 'paragraph',
                text: 'A lot of people come into our roasting class not knowing what to expect — and leave with a completely new relationship with coffee. That\'s the whole point.'
            },
            {
                type: 'heading',
                text: 'It Starts with the Bean'
            },
            {
                type: 'paragraph',
                text: 'Before we touch a roaster, we talk origins. Where the bean was grown, at what altitude, what processing method was used. These details aren\'t just trivia — they\'re the foundation of every roasting decision you\'ll make. A washed Ethiopian from 2,000 meters needs to be treated very differently than a natural processed Brazilian.'
            },
            {
                type: 'heading',
                text: 'Getting Hands-On with the Roaster'
            },
            {
                type: 'paragraph',
                text: 'Students take turns at the drum roaster, learning to read the visual and aromatic cues that mark each stage: drying, Maillard browning, first crack, and development. We guide you through the full roast profile and explain why time and temperature decisions shape the final cup.'
            },
            {
                type: 'heading',
                text: 'Cupping Your Roast'
            },
            {
                type: 'paragraph',
                text: 'After the roast cools, we cup it together. You\'ll taste what you made, identify the flavor notes, and understand why the choices you made matter. It\'s one thing to read about coffee — it\'s another to drink something you built from a green bean.'
            },
            {
                type: 'paragraph',
                text: 'Classes are available as private sessions and team-building experiences. Visit our Booking page to reserve your spot.'
            },
        ]
    },
    {
        slug: 'yemen-mokha-matari',
        title: 'Yemen Mokha Matari: A Coffee Worth Savoring',
        date: 'February 12, 2026',
        category: 'Origins',
        image: '/images/Yemen Mokha.jpg',
        excerpt: 'One of the rarest and most historically significant coffees in the world — here\'s why Yemen Mokha Matari has earned a special place in our lineup.',
        content: [
            {
                type: 'paragraph',
                text: 'If you\'ve ever wondered where the word "mocha" came from, it\'s Yemen. The port city of Al-Mokha was the world\'s primary coffee trading hub for centuries, and Yemeni coffee was the original specialty.'
            },
            {
                type: 'heading',
                text: 'What Makes It Rare'
            },
            {
                type: 'paragraph',
                text: 'Yemen Mokha Matari is grown in the Bani Matari region at elevations above 2,000 meters, largely without irrigation, on ancient terraced farms. The beans are typically small, irregular, and processed using traditional dry methods that have changed little in hundreds of years. Supply is extremely limited and inconsistent — which is why we offer it in 8 oz only.'
            },
            {
                type: 'heading',
                text: 'What\'s in the Cup'
            },
            {
                type: 'paragraph',
                text: 'Expect a complex, wine-like cup with notes of dried fruit, dark chocolate, and a distinctive earthy depth that you won\'t find anywhere else. It\'s a coffee that rewards slow, attentive drinking. We recommend brewing it as a pour-over or French press to let the character open up.'
            },
            {
                type: 'paragraph',
                text: 'Yemen Mokha Matari is available as a single-origin 8 oz bag in our shop. Because of limited availability, we recommend ordering early.'
            },
        ]
    },
    {
        slug: 'guatemala-gesha',
        title: 'Guatemala Gesha: The Rare Gem of Coffee',
        date: 'February 5, 2026',
        category: 'Origins',
        image: '/images/guatemala.png',
        excerpt: 'The Gesha variety has taken the specialty coffee world by storm. Here\'s what makes our Guatemala Gesha exceptional and why it commands its price.',
        content: [
            {
                type: 'paragraph',
                text: 'Gesha (also spelled Geisha) is one of the most sought-after coffee varieties in the world. Originally from Ethiopia, it found its most celebrated expression in Panama — and now extraordinary Gesha coffees are being grown in Guatemala\'s high-altitude regions.'
            },
            {
                type: 'heading',
                text: 'Why Gesha Is Different'
            },
            {
                type: 'paragraph',
                text: 'The Gesha plant produces an elongated, delicate bean that is notoriously difficult to grow and low-yielding. But the cup quality it delivers is unlike anything in coffee: floral aromas, jasmine, bergamot, stone fruit, and a tea-like clarity that makes experienced drinkers stop mid-sip.'
            },
            {
                type: 'heading',
                text: 'Our Guatemala Gesha'
            },
            {
                type: 'paragraph',
                text: 'We source our Guatemala Gesha from high-altitude farms in the Huehuetenango region, where cool temperatures and distinct wet and dry seasons slow cherry development and concentrate flavor. We roast it light, because the best Gesha doesn\'t need much — just enough heat to open it up.'
            },
            {
                type: 'paragraph',
                text: 'Available as an 8 oz bag in our shop. Given the rarity of this lot, quantities are limited.'
            },
        ]
    },
    {
        slug: 'single-origin-vs-blend',
        title: 'Single Origin vs. Blend: Which Is Right for You?',
        date: 'January 28, 2026',
        category: 'Coffee Education',
        image: '/images/SOE or blend.jpg',
        excerpt: 'Both have their place in a great coffee lineup. Here\'s how to think about the choice and when each one shines.',
        content: [
            {
                type: 'paragraph',
                text: 'When you\'re building your coffee order, one of the first choices is single origin or blend. Neither is better — they\'re just different tools for different moments.'
            },
            {
                type: 'heading',
                text: 'Single Origin'
            },
            {
                type: 'paragraph',
                text: 'A single origin coffee comes from one place — one country, one region, sometimes one specific farm. This gives you a clear, traceable flavor story. Ethiopian coffees often carry floral and fruity notes. Kenyan coffees lean toward bright acidity and berry. Indonesian coffees tend to be earthy and full-bodied. When you drink single origin, you\'re drinking a place.'
            },
            {
                type: 'heading',
                text: 'Blends'
            },
            {
                type: 'paragraph',
                text: 'A well-crafted blend balances different origins to create something consistent and complex that neither origin could achieve alone. A roaster might combine a bright, acidic Ethiopian with a body-heavy Brazilian to create an everyday cup that\'s balanced and reliable. Blends are also typically more forgiving across different brew methods.'
            },
            {
                type: 'heading',
                text: 'Our Take'
            },
            {
                type: 'paragraph',
                text: 'At OFFF THE ROAST, we let you build both. Choose your regions, your roast level, and your size — and we\'ll roast it to order. If you\'re exploring, start with a single origin. If you\'re looking for your daily driver, experiment with blending two or three regions you already enjoy.'
            },
        ]
    },
    {
        slug: 'team-building-with-coffee',
        title: 'Why Coffee Roasting Makes the Best Team-Building Experience',
        date: 'January 20, 2026',
        category: 'Classes',
        image: '/images/teambuildingfigure.jpg',
        excerpt: 'Team happy hours are great. But hands-on roasting together creates something different — here\'s why companies keep coming back.',
        content: [
            {
                type: 'paragraph',
                text: 'We\'ve hosted teams from startups, enterprise companies, and everything in between. Every group comes in a little different, and every group leaves talking to each other differently. That\'s not an accident.'
            },
            {
                type: 'heading',
                text: 'A Shared Learning Curve'
            },
            {
                type: 'paragraph',
                text: 'Unlike activities where skill level divides the group, roasting puts everyone on equal footing. Nobody comes in already knowing how to read a roast. The learning curve is shared, and that shared vulnerability — trying something new together — is one of the fastest ways to build real connection.'
            },
            {
                type: 'heading',
                text: 'Collaboration Built Into the Process'
            },
            {
                type: 'paragraph',
                text: 'A good roast requires communication. One person watches temperature, another monitors time, someone else tracks color and smell. Teams naturally divide into roles and then have to coordinate. It\'s a lightweight version of the same dynamics they navigate every day at work — but with coffee instead of deliverables.'
            },
            {
                type: 'heading',
                text: 'Something to Take Home'
            },
            {
                type: 'paragraph',
                text: 'Every participant leaves with a bag of what they roasted. That\'s a tangible outcome, and it keeps the conversation going long after the session ends. We\'ve had teams tell us they still talk about their roast months later.'
            },
            {
                type: 'paragraph',
                text: 'Team-building sessions are available for groups of all sizes. Reach out through our Booking page or Contact page to plan your session.'
            },
        ]
    },
];
